<template>
  <div id="app">

    <Head></Head>
    <!-- <RightImg></RightImg> -->
    <div style="min-height: calc(100vh - 180px)">
      <router-view />
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Head from "@/components/head.vue";
import RightImg from "@/components/rightImg.vue";
import Footer from "@/components/footer.vue";
export default {
  components: {
    Head,
    RightImg,
    Footer,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
<style>
* {
  margin: 0;
  padding: 0;
}

div {
  box-sizing: border-box;
}

@font-face {
  font-family: "logo";
  src: url("../src/assets/font/logo.ttf");
}

.my-wp {
  margin: 0 auto;
  padding-top: 14px;
}

.swiper-button-next,
.swiper-button-prev {
  color: #00000050 !important;

}

.swiper-button-next:after,
.swiper-button-prev:after {
  font-size: 20px !important;
}

.bpx-player-video-wrap video {
  object-fit: cover;
}
</style>